import { UrlConstants } from "../url.constants";
export class ApiRecipientGroupSettingsConstants {
    static URL = UrlConstants.API_V2 + "RecipientGroupSetting";
    static FUNCTION_GET_AFLA_PORTAL_RECIPIENT_GROUPS = "GetAFLAPortalRecipientGroups";
}
